import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { StyledTag } from '../../Tag/styles';

export const StyledSubMenu = styled.div`
  z-index: ${themeGet('zIndex.zIndex02')};

  a:not(.arrow-link) {
    ${themeGet('font.whitneyMedium')}
    color: ${themeGet('color.colorGrayBlue90')};
    text-decoration: none;
    font-size: ${themeGet('scale.scaleDown01')};

    &:hover {
      text-decoration: underline;
      color: ${themeGet('color.colorGrayBlue90')};
    }
  }

  ${StyledTag} {
    font-size: ${themeGet('scale.scaleDown03')};
    padding: ${themeGet('scale.scaleDown05')} ${themeGet('scale.scaleDown04')};
    top: 0;
    vertical-align: middle;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
  }
`;

export const StyledSubMenuGrid = styled.div`
  > div {
    padding: ${themeGet('scale.scaleUp08')} ${themeGet('scale.scaleUp03')};

    &:first-of-type {
      padding-top: ${themeGet('scale.scaleUp03')};
      padding-bottom: ${themeGet('scale.scaleDown03')};
    }

    &:last-of-type {
      background: ${themeGet('color.colorGrayBlue20')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    > div {
      padding: ${themeGet('scale.scaleUp07')};

      &:first-of-type {
        padding-top: ${themeGet('scale.scaleUp05')};
        padding-bottom: ${themeGet('scale.scaleBase')};
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    display: grid;
    grid-template-columns: 37% auto 29%;
    grid-column-gap: ${themeGet('scale.scaleUp05')};

    > div,
    > div:first-of-type,
    > div:last-of-type {
      padding: 0;
      padding: ${themeGet('scale.scaleUp08')} 0;
    }

    > div:first-of-type {
      padding-left: ${themeGet('scale.scaleUp05')};
    }

    > div:last-of-type {
      padding: ${themeGet('scale.scaleUp08')} ${themeGet('scale.scaleUp05')};
      background: transparent;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavXl')}) {
    > div:first-of-type {
      padding-left: 23%;
    }

    > div:last-of-type {
      padding-left: ${themeGet('scale.scaleUp07')};
      padding-right: 30%;
    }
  }
`;

export const StyledSubMenuBg = styled.div`
  background: linear-gradient(
    to right,
    ${themeGet('color.colorGrayBlue10')} 71%,
    ${themeGet('color.colorGrayBlue20')} 71.1%
  );
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateY(100%);
  z-index: ${themeGet('zIndex.zIndex01')};
`;

export const StyledBanner = styled.div`  
  background: ${themeGet('color.colorBlue100')};
  color: ${themeGet('color.colorWhite')};
  text-align: center;
  padding: ${themeGet('scale.scaleBase')} ${themeGet('scale.scaleUp06')}
    ${themeGet('scale.scaleUp03')};

  ${StyledTag} {
    box-shadow: none;
    color: white;
    background: rgba(255,255,255,0.3);
    margin: 0;
  }

  p {
    color: ${themeGet('color.colorWhite')};
  }

  p:first-of-type {
    ${themeGet('font.whitneyMedium')}
    font-size: ${themeGet('scale.scaleDown01')};
    margin: ${themeGet('scale.scaleDown03')} 0;
  }

  p:last-of-type {
    margin: 0;
  }

  .arrow-link {
    color: inherit;
    font-size: ${themeGet('scale.scaleDown02')};

    :hover {
      color: inherit;
    }

    ::before,
    :hover::before {
      background: ${themeGet('color.colorWhite')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    padding: ${themeGet('scale.scaleBase')};

    ${StyledTag} {
      margin-right: ${themeGet('scale.scaleDown02')};
    }

    p:first-of-type {
      display: inline-block;
      margin-top: 0;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    padding: ${themeGet('scale.scaleDown03')} 8.5%;
    text-align: left;
    box-shadow: 0 40px 64px 0 rgba(44, 74, 125, 0.08);

    .arrow-link {
      position: relative;
      top: -2px;
      line-height: 1;
    }

    p:first-of-type {
      margin: 0 ${themeGet('scale.scaleBase')} 0 0;
    }

    p:last-of-type {
      display: inline-block;
    }
  }
`;
